export enum SolutionStatusValue {
  ACTIVE = "active",
  EXPIRING = "expiring",
  EXPIRED = "expired",
}

export enum ContractTypeValue {
  ESIGN = "esign",
  DIRECT = "direct",
}

export enum PaymentMethodValue {
  BANKING = "banking",
  CARD = "card",
}

export enum VatTypeValue {
  COMPANY = "enterprise",
  PERSONAL = "personal",
}
